import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'

import { InsaCronService, LocalizeService } from '../../../../../insa-services';
import { ChronosJobListColumnDef } from '../../../';
import { ChronosActivityResultActions, ChronosActivitiesModel } from '../../../../../insa-models';

import { appStateProvider } from '../../../../../insa-providers';

import { customGroupHeader } from '../../../../../insa-custom-scripts'

@Component({
    selector: "post-action",
    template: require("./post-action.component.html")
})

export class PostActionComponent implements OnInit {
    //_jobID: number = null;
    //_activityID: number = null;
    //_postActivityID: number = null;
    _selectedActivityData: any;
    _prioritiesList: any;

    @Input() set selectedActivityData(selectedActivity: any) {
        (selectedActivity == undefined) ? this._selectedActivityData = new ChronosActivitiesModel() : this._selectedActivityData = selectedActivity;
    }
    @Input() set allActivities(allActivities: any) {
        this.activities = allActivities.filter(act => {
            if(act.ActivityID !== this._selectedActivityData.ActivityID){
                return act;
            }
        })
    }
    @Input() set priorities(pl: Array<Object>){ this._prioritiesList = pl; }
    //@Input() set allActivities(allActivities: any){this.activities = allActivities}
    //@Input() set postActivityID(postActivityID: number) { this._postActivityID = postActivityID }
    //@Input() set activityID(activityID: number) { (activityID == undefined) ? this._activityID = null : this._activityID = activityID; }
    //@Input() set jobID(jobId: number) { (jobId == undefined) ? this._jobID = null : this._jobID = jobId; }

    @Output() addOrEditPostAction: EventEmitter<ChronosActivityResultActions[]> = new EventEmitter<ChronosActivityResultActions[]>(true);
    @Output() emitPostAction: EventEmitter<ChronosActivitiesModel> = new EventEmitter<ChronosActivitiesModel>(true);

    //private jobAcitivtiesListSubscription;
    private isEditSelected: boolean = false;
    private isDeleteSelected: boolean = false;
    private isAddSelected: boolean = false;
    selectedItem: any;
    private activities: any = [];
    postActionData: any = [];
    submittedActivity: any[] = [];
    //@Input() priorities: Array<any>;
    //private prior: any;
    //private submitted: boolean = false;
    //private activityTypes: any = [];
    //priorityID: number = null;

    //_postActivity: ChronosActivitiesModel = new ChronosActivitiesModel();
    /*@Input() set postActivity(activity: ChronosActivitiesModel){
        (activity===undefined) ? this._postActivity = new ChronosActivitiesModel() : this._postActivity = activity;
    }*/

    constructor(private _insaChronosService: InsaCronService, private _appStateProvider: appStateProvider, private _localize: LocalizeService) {}


    private refreshPostActivitiesList() {
        if (this._selectedActivityData.ActivityID !== null && this._selectedActivityData.ActivityID !== null) {
            this._insaChronosService.getPostActions(this._selectedActivityData.ActivityID).subscribe(d => {
                this.postActionData = d,
                this.InitPostActionGrid(this.createPostActionColumnDefs(), d);
            })
        }else{
            this.InitPostActionGrid(this.createPostActionColumnDefs(), []);
        }       
    }

    private createPostActionColumnDefs() {
        let postActionsColumnDefs = new Array<ChronosJobListColumnDef>();

        let postactivitiesColumn: ChronosJobListColumnDef = new ChronosJobListColumnDef("PostActivityID", "Post-Activity Name");
        if (this.activities !== undefined && this.activities !== null) {
            postactivitiesColumn.values = this.activities.map(function (item) {
                let postActivityData: Object = { text: item.Description, value: item.ActivityID }
                return postActivityData;
            })
        }

        let priorityColumn: ChronosJobListColumnDef = new ChronosJobListColumnDef("PriorityID", "Priority");
        priorityColumn.hidden = false;
        //activityTypeColumn.template = undefined;
        if (this._prioritiesList !== undefined) {
            //priorityColumn.values = this.priorities.map(function (itemPriority) {
                priorityColumn.values = this._prioritiesList.map(function (itemPriority){
                    let priorityData: Object = { text: itemPriority.Description1, value: itemPriority.PriorityID };
                    return priorityData;
                });
            }
            postActionsColumnDefs.push(postactivitiesColumn);
            postActionsColumnDefs.push(priorityColumn);
            
            return postActionsColumnDefs;
    }

    getPostAction(activity) {
        this.submittedActivity = activity;
        //this.priorityID = postAction.priorityID;
        this.InitPostActionGrid(this.createPostActionColumnDefs(), activity.PostActivities);
        this.emitPostAction.emit(activity);
    }
    // please check this- it broke modal.backdrop when closing modal in Chronos MK0519
     private destroyComponent(event) {
         this.hideModal();
     }

    private getPostActionFromRow(e) {
        e.preventDefault();
        let postActivitiesList: kendo.ui.Grid = $("#PostActions").data("kendoGrid");
        let tr = $(e.target).closest("tr");

        //get selected button action by Id
        let target = e.target || e.srcElement || e.currentTarget;
        let idAttr = target.attributes.id;
        let actionValue = idAttr.nodeValue;

        switch (actionValue) {
            case "editPostActBtn": {
                this.isEditSelected = true;
                this.selectedItem = postActivitiesList.dataItem(tr);
                //this._selectedActivityData.PostActivities = this.postActionData;
                break;
            }
            case "deletePostActBtn": {
                this.isDeleteSelected = true;
                this.selectedItem = postActivitiesList.dataItem(tr);
                let postActivityID = this.selectedItem.PostActivityID;
                let activityID = this.selectedItem.ActivityID;
                let priorityID = this.selectedItem.PriorityID;

                this._selectedActivityData.PostActivities = this.postActionData;

                this._selectedActivityData.PostActivities.filter((d, index) => {
                    if (d.ActivityID == activityID && d.PostActivityID == postActivityID && d.PriorityID == priorityID) {
                        this._selectedActivityData.PostActivities.splice(index, 1)
                        return this._selectedActivityData.PostActivities;
                    }
                })
                break;
            }
            default: {
                console.log("Invalid choice");
                break;
            }
        }
    }

    private deletePostAction() {
        /*this._insaChronosService.updateJobActivity(this._selectedActivityData).subscribe(d => {
            //this._insaChronosService.getActivityByJobId(this._jobID).subscribe()
            //his._insaChronosService.getActivityByJobId(this._selectedActivityData.JobID).subscribe()
            this.refreshPostActivitiesList()
        })*/
        let activity = this._selectedActivityData;
        this.emitPostAction.emit(activity);
        this.isDeleteSelected = false;
        this.InitPostActionGrid(this.createPostActionColumnDefs(), activity.PostActivities)
        // this.emitPostAction.emit(this._selectedActivityData); 
    }

    addPostActivity() {
        this.isAddSelected = true;
        this.selectedItem = new ChronosActivityResultActions();
    }

 hideModal() {
         this.isEditSelected = false;
         this.isDeleteSelected = false;
         this.isAddSelected = false;
     }

    private onResize(event) {
        let postActionGrid: kendo.ui.Grid = $("#PostActions").data("kendoGrid");
        if (postActionGrid !== undefined) {
            postActionGrid.options.height = $(".gridResize").height();
            postActionGrid.resize();
        }
    }

    private InitPostActionGrid(columnDefs, griddata) {

        let dataSourceOptions: kendo.data.DataSourceOptions = {};
        dataSourceOptions.data = griddata;
        dataSourceOptions.schema = {
            model: {
                fields: {
                    ActivityID: { type: "number" },
                    PriorityID: { type: "number" },
                    PostActivityID: { type: "number" }
                }
            }
        };

        let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);
        columnDefs.push({
            width: 15, command: [
                {
                    name: "editPostActBtn",
                    //text:'EDIT',
                    className: 'k-icon k-i-edit',
                    click: this.getPostActionFromRow.bind(this)
                }
            ]
        });
        columnDefs.push({
            width: 15, command: [
                {
                    name: "deletePostActBtn",
                    //text:'DELETE',
                    className: 'k-icon k-i-delete',
                    click: this.getPostActionFromRow.bind(this)
                }
            ]
        });

        let postActionGrid: kendo.ui.Grid = $("#PostActions").data("kendoGrid");

        if (postActionGrid === undefined) {
            let postActionGridOptions: kendo.ui.GridOptions = {};
            postActionGridOptions.dataSource = dataSource;
            postActionGridOptions.filterable = false;
            postActionGridOptions.height = 300;
            postActionGridOptions.sortable = true;
            postActionGridOptions.selectable = true;
            postActionGridOptions.reorderable = true;
            postActionGridOptions.scrollable = true;
            postActionGridOptions.noRecords = { template: "<p class='center no-data-message'>NO DATA</p>" };
            postActionGridOptions.groupable = true;
            postActionGridOptions.pageable = false;
            postActionGridOptions.resizable = true;
            postActionGridOptions.columns = columnDefs;

            postActionGridOptions.dataBound = customGroupHeader.KendoGridDataBound;

            $("#PostActions").kendoGrid(postActionGridOptions);
            postActionGrid = $("#PostActions").data("kendoGrid");
        }
        else {
            postActionGrid.setDataSource(dataSource);
        }

    }
    ngOnInit(){
        this.refreshPostActivitiesList()  
    }
    ngAfterViewInit() {
        //kendo.ui.progress($(".postActionGrid-loading"), this._appStateProvider.fetchingChronosPostActivities);
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-form/insa-post-actions/post-action.component.ts